import { ConfigForm } from "../form";

export class ModalVisualizarData
{
    public titulo: string;
    public entity: any;
    public configForm: ConfigForm;
    public fechar: (entity: any) => any;
}
